import React, { useState } from "react";
import { mdiClose, mdiDoor, mdiPlus, mdiPlusCircleOutline } from "@mdi/js";
import MdiIcon from "../../../components/device/app/MdiIcon";
import AppSwitch from "../../../components/layout/app/AppSwitch";
import { EVERY_DAY } from "./draft";
import { Card, DayCircles, Hint, Label, Segmented, TimeBox } from "./controls";

const DOOR_STATES = [
  { key: "closed", label: "Is closed", value: true },
  { key: "open", label: "Is open", value: false },
];

// Only if… a time window, some days, another door's state. All optional.
// Schedules and sunrise/sunset already have their days, and a schedule its
// time, so those cards are left out for them
// (app/screens/Automation/create/ConditionsStep.js).
export default function ConditionsStep({ type, draft, onConditions, doors, lookup }) {
  const { window, days, devices } = draft.conditions;
  const [adding, setAdding] = useState(false);
  const set = (changes) => onConditions({ ...draft.conditions, ...changes });
  const unused = doors.filter(
    (door) => door.applianceId !== draft.trigger.applianceId && !devices.some((c) => c.applianceId === door.applianceId)
  );

  const showWindow = type !== "schedule";
  const showDays = type === "rule" || type === "location";

  return (
    <>
      {showWindow ? (
        <Card>
          <div className="hx-auto-step-row">
            <Label>Time window</Label>
            <AppSwitch
              checked={Boolean(window)}
              onChange={(on) => set({ window: on ? { from: "23:00", to: "05:00" } : null })}
              label="Time window"
            />
          </div>
          {window ? (
            <>
              <div className="hx-auto-window">
                <TimeBox value={window.from} onChange={(from) => set({ window: { ...window, from } })} label="From" />
                <span>to</span>
                <TimeBox value={window.to} onChange={(to) => set({ window: { ...window, to } })} label="To" />
              </div>
              <Hint>Runs only between these times.</Hint>
            </>
          ) : null}
        </Card>
      ) : null}

      {showDays ? (
        <Card>
          <div className="hx-auto-step-row">
            <Label>Days</Label>
            <AppSwitch checked={Boolean(days)} onChange={(on) => set({ days: on ? EVERY_DAY : null })} label="Days" />
          </div>
          {days ? <DayCircles days={days} onChange={(value) => set({ days: value })} label="Only on" /> : null}
        </Card>
      ) : null}

      {unused.length || devices.length ? (
        <Card>
          <Label>Another device</Label>
          {devices.map((condition) => {
            const name = lookup.name(condition.applianceId);
            return (
              <div key={condition.applianceId} className="hx-auto-condition">
                <MdiIcon path={mdiDoor} size={20} />
                <div>
                  <p>{name}</p>
                  <Segmented
                    compact
                    label={name}
                    options={DOOR_STATES}
                    value={condition.value ? "closed" : "open"}
                    onChange={(key) =>
                      set({
                        devices: devices.map((c) => (c.applianceId === condition.applianceId ? { ...c, value: key === "closed" } : c)),
                      })
                    }
                  />
                </div>
                <button
                  type="button"
                  className="hx-icon-btn hx-auto-remove"
                  onClick={() => set({ devices: devices.filter((c) => c.applianceId !== condition.applianceId) })}
                  aria-label={`Remove ${name}`}
                >
                  <MdiIcon path={mdiClose} size={22} />
                </button>
              </div>
            );
          })}
          {adding ? (
            unused.map((door) => (
              <button
                key={door.applianceId}
                type="button"
                className="hx-auto-pick-row"
                onClick={() => {
                  set({ devices: [...devices, { applianceId: door.applianceId, fact: "isClosed", value: true }] });
                  setAdding(false);
                }}
              >
                <MdiIcon path={mdiPlusCircleOutline} size={20} />
                <span>{door.name}</span>
              </button>
            ))
          ) : unused.length ? (
            <button type="button" className="hx-btn hx-auto-add-condition" onClick={() => setAdding(true)}>
              <MdiIcon path={mdiPlus} size={18} />
              Add condition
            </button>
          ) : null}
        </Card>
      ) : null}
    </>
  );
}
